import { Query } from 'utility-ts-orm';
import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ISchedulerStudentPlan } from '../interfaces/scheduler_student_plan';
import { ISchedulerStudentPlanDatasource } from '../datasource/student_plans_datasource';

export class SchedulerStudentPlanQuery implements IQuery {
  get result() {
    return this._result;
  }

  private _result?: ISchedulerStudentPlan;

  constructor(private ngSchedulerStudentPlanDatasource: ISchedulerStudentPlanDatasource) {
    Query.registerQuery(this, this.ngSchedulerStudentPlanDatasource);
  }

  run() {
    const plans = this.ngSchedulerStudentPlanDatasource.values();
    this._result = _4.find(plans, { is_primary: true });
    return this;
  }
}

angular.module('capability-ng-scheduler').service('ngSchedulerStudentPlanQuery', SchedulerStudentPlanQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/search_and_add_courses/queries/scheduler_student_plan_query.ts